function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".resourceT_svg__st0{fill:none}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 14.5h-4c-.3 0-.5.2-.5.5s.2.5.5.5H17V21c0 .3.2.5.5.5s.5-.2.5-.5v-5.5h1.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 11c-3.4 0-6.2 2.7-6.5 6v1c.3 3.6 3.4 6.2 7 5.9 3.6-.3 6.2-3.4 5.9-7-.2-3.3-3-5.9-6.4-5.9zm0 12c-2.9 0-5.4-2.3-5.5-5.3v-.2c0-2.9 2.3-5.4 5.2-5.5h.3c3 0 5.5 2.5 5.5 5.5S20.5 23 17.5 23z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, React.createElement("path", {
  className: "resourceT_svg__st0",
  d: "M10.1 2.8s-.1 0 0 0h-.2L2.2 5.3l7.3 2.5 7.4-2.5-6.8-2.5zM1 6v10.5c0 .2.1.4.3.5L9 19.5V8.6L1 6z"
}), React.createElement("path", {
  className: "resourceT_svg__st0",
  d: "M1 6v10.5c0 .2.1.4.3.5L9 19.5V8.6L1 6zM10 2.8h-.1L2.2 5.3l7.3 2.5 7.4-2.5L10 2.8c.1 0 0 0 0 0z"
}), React.createElement("path", {
  className: "resourceT_svg__st0",
  d: "M1 6v10.5c0 .2.1.4.3.5L9 19.5V8.6L1 6zM10 2.8h-.1L2.2 5.3l7.3 2.5 7.4-2.5L10 2.8c.1 0 0 0 0 0z"
}), React.createElement("path", {
  d: "M18 8.5c0 .3.2.5.5.5s.5-.2.5-.5V6c0-.4-.1-.7-.4-1 0-.1-.1-.1-.1-.1-.2-.2-.4-.3-.6-.3l-7.5-2.7c-.3-.1-.5-.1-.8 0L1.1 4.6c-.2 0-.4.1-.6.3L.4 5c-.3.3-.4.6-.4 1v10.5c0 .6.4 1.2 1 1.4l8.2 2.7c.6.2.8-.1.8-.5V8.5l8-2.7v2.7zm-9 11L1.3 17c-.2-.1-.3-.2-.3-.5V6v-.1l8 2.7v10.9zm.5-11.8L2.2 5.3l7.7-2.5h.2l6.8 2.5-7.4 2.4z"
}));

function SvgResourceT(props) {
  return React.createElement("svg", _extends({
    id: "resourceT_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "resourceT.f5903.svg";
export { SvgResourceT as ReactComponent };